import PropTypes from 'prop-types';

export default PropTypes.shape({
  logo: PropTypes.shape({ fullSize: PropTypes.object }).isRequired,
  name: PropTypes.string.isRequired,
  position: PropTypes.string.isRequired,
  testimonial: PropTypes.shape({ text: PropTypes.string }).isRequired,
});



// WEBPACK FOOTER //
// ./src/types/TestimonialType.js